import React from 'react';
import isPropValid from '@emotion/is-prop-valid';
import { StyledEngineProvider } from '@mui/material/styles';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { StyleSheetManager } from 'styled-components';
import App from './App';
import './assets/css/font.css';
import './assets/css/global.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <StyledEngineProvider injectFirst>
        <StyleSheetManager shouldForwardProp={isPropValid}>
          <App />
        </StyleSheetManager>
      </StyledEngineProvider>
    </BrowserRouter>
  </React.StrictMode>
);
